
import { INCOME_TYPES, EXPENSE_TYPES } from './incomeAndExpenceTypes';
import { INPUT_TYPES } from '../../inputs/inputTypes';
import { FREQUENCY_TYPES } from './frequencyTypes';
import { VALIDATION_TYPES } from '../../inputs/validationTypes';


export const FREQUENCY_OPTIONS_TYPES = {
    'type_0': [],
    'type_1': [
        'default',
        FREQUENCY_TYPES.HOURLY,
        FREQUENCY_TYPES.DAILY,
        FREQUENCY_TYPES.WEEKLY,
        FREQUENCY_TYPES.BIWEEKLY,
        FREQUENCY_TYPES.BIMONTHLY,
        FREQUENCY_TYPES.MONTHLY,
        FREQUENCY_TYPES.YEARLY,
        FREQUENCY_TYPES.ONCE
    ],
    'type_2': [
        'default',
        FREQUENCY_TYPES.WEEKLY,
        FREQUENCY_TYPES.BIWEEKLY,
        FREQUENCY_TYPES.BIMONTHLY,
        FREQUENCY_TYPES.MONTHLY,
        FREQUENCY_TYPES.YEARLY,
        FREQUENCY_TYPES.ONCE
    ],
    'type_3': [
        'default',
        FREQUENCY_TYPES.MONTHLY,
        FREQUENCY_TYPES.QUARTERLY,
        FREQUENCY_TYPES.YEARLY,
        FREQUENCY_TYPES.ONCE
    ],
    'type_4': [
        'default',
        FREQUENCY_TYPES.MONTHLY
    ],
    'type_5': [
        'default',
        FREQUENCY_TYPES.YEARLY
    ],
    'type_6': [
        'default',
        FREQUENCY_TYPES.WEEKLY,
        FREQUENCY_TYPES.BIWEEKLY,
        FREQUENCY_TYPES.BIMONTHLY,
        FREQUENCY_TYPES.MONTHLY,
        FREQUENCY_TYPES.YEARLY
    ]
};

// Positions:
//  for notices:
//      0 -   between <incomeType> and <additionalInput> on position 1
//      1 -   between <incomeType> and <additionalInput> on position 1 but before common question 'How much...'
//      2 -   between <incomeType> and <amountInput> (there is no <additionalInput> on position 1)
//      3 -   between <amount> and <profitOrLoss>
//
//  for additional inputs:
//      1 - between <incomeType> and <amount>
//      2 - between <amount> and <frequency>
//      3 - after <frequency>

export const INCOME_SOURCES = [
    {
        type: INCOME_TYPES.ALIMONY,
        isOnlyPositiveAvailable: true,
        questionText: 'modals.income_deduction.income_from_alimony',
        notice: {
            text: 'common.no_text',
            positionOnPage: null
        },
        additionalInput: {
            positionOnPage: null
        },
        frequencyOptions: 'type_2'
    },
    {
        type: INCOME_TYPES.CAPITAL_GAIN,
        questionText: 'modals.income_deduction.capital_gain',
        notice: {
            text: 'modals.income_deduction.capital_gain.notice',
            positionOnPage: 2
        },
        additionalInput: {
            additionalInputName: 'profitOrLoss',
            additionalInputText: 'ssap.input.label.profit_loss',
            inputType: INPUT_TYPES.DROPDOWN,
            required: true,
            positionOnPage: 2
        },
        frequencyOptions: 'type_5'
    },
    {
        type: INCOME_TYPES.INVESTMENT,
        isOnlyPositiveAvailable: true,
        questionText: 'modals.income_deduction.dividends',
        notice: {
            text: 'common.no_text',
            positionOnPage: null
        },
        additionalInput: {
            positionOnPage: null
        },
        frequencyOptions: 'type_3'
    },
    {
        type: INCOME_TYPES.FARMING_FISHING,
        isOnlyPositiveAvailable: true,
        questionText: 'modals.income_deduction.farming_fishing',
        notice: {
            text: 'common.no_text',
            positionOnPage: null
        },
        additionalInput: {
            positionOnPage: null
        },
        frequencyOptions: 'type_2'
    },
    {
        type: INCOME_TYPES.JOB,
        isOnlyPositiveAvailable: true,
        questionText: 'modals.income_deduction.job',
        notice: {
            text: 'common.no_text',
            positionOnPage: null
        },
        additionalInput: {
            additionalInputName: 'employerName',
            additionalInputText: 'ssap.input.label.employer_name',
            inputType: INPUT_TYPES.REGULAR_INPUT,
            required: true,
            positionOnPage: 1,
            validationType: VALIDATION_TYPES.EMPLOYER_NAME
        },
        frequencyOptions: 'type_1'
    },
    {
        type: INCOME_TYPES.OTHER,
        isOnlyPositiveAvailable: true,
        questionText: 'modals.income_deduction.other_sources',
        notice: {
            text: 'modals.income_deduction.other_sources.notice',
            positionOnPage: 1
        },
        additionalInput: {
            additionalInputName: 'otherIncomeTypes',
            additionalInputText: 'ssap.input.label.income_type',
            inputType: INPUT_TYPES.DROPDOWN,
            required: true,
            positionOnPage: 1
        },
        frequencyOptions: 'type_2'
    },
    {
        type: INCOME_TYPES.PENSION,
        isOnlyPositiveAvailable: true,
        questionText: 'modals.income_deduction.pension',
        notice: {
            text: 'common.no_text',
            positionOnPage: null
        },
        additionalInput: {
            positionOnPage: null
        },
        frequencyOptions: 'type_2'
    },
    {
        type: INCOME_TYPES.RETIREMENT,
        isOnlyPositiveAvailable: true,
        questionText: 'modals.income_deduction.retirement',
        notice: {
            text: 'modals.income_deduction.retirement.notice',
            positionOnPage: 2
        },
        additionalInput: {
            positionOnPage: null
        },
        frequencyOptions: 'type_2'
    },
    {
        type: INCOME_TYPES.RENTAL_ROYALTY,
        questionText: 'modals.income_deduction.rental_royalty',
        notice: {
            text: 'common.no_text',
            positionOnPage: null
        },
        additionalInput: {
            additionalInputName: 'profitOrLoss',
            additionalInputText: 'ssap.input.label.profit_loss',
            inputType: INPUT_TYPES.DROPDOWN,
            required: true,
            positionOnPage: 2
        },
        frequencyOptions: 'type_2'
    },
    {
        type: INCOME_TYPES.SCHOLARSHIP,
        isOnlyPositiveAvailable: true,
        questionText: 'modals.income_deduction.scholarship',
        notice: {
            text: 'modals.income_deduction.scholarship.notice',
            positionOnPage: 3
        },
        additionalInput: {
            additionalInputName: 'educationExpenses',
            additionalInputText: 'ssap.input.label.educational_expenses',
            inputType: INPUT_TYPES.MONEY_INPUT,
            isOnlyPositiveAvailable: true,
            required: true,
            positionOnPage: 3
        },
        frequencyOptions: 'type_2'
    },
    {
        type: INCOME_TYPES.SELF_EMPLOYMENT,
        questionText: 'modals.income_deduction.self_employment',
        notice: {
            text: 'modals.income_deduction.self_employment.notice',
            positionOnPage: 2
        },
        additionalInput: {
            additionalInputName: 'profitOrLoss',
            additionalInputText: 'ssap.input.label.profit_loss',
            inputType: INPUT_TYPES.DROPDOWN,
            required: true,
            positionOnPage: 2
        },
        frequencyOptions: 'type_4'
    },
    {
        type: INCOME_TYPES.SOCIAL_SECURITY_DISABILITY,
        isOnlyPositiveAvailable: true,
        questionText: 'modals.income_deduction.social_security',
        notice: {
            text: 'modals.income_deduction.social_security.notice',
            positionOnPage: 2
        },
        additionalInput: {
            positionOnPage: null
        },
        frequencyOptions: 'type_3'
    },
    {
        type: INCOME_TYPES.UNEMPLOYMENT,
        isOnlyPositiveAvailable: true,
        questionText: 'common.no_text',
        notice: {
            text: 'modals.income_deduction.unemployment.notice',
            positionOnPage: 0
        },
        additionalInput: {
            additionalInputName: 'unemploymentSource',
            additionalInputText: 'ssap.input.label.state_or_employer',
            inputType: INPUT_TYPES.REGULAR_INPUT,
            required: false,
            positionOnPage: 1
        },
        frequencyOptions: 'type_2'
    },
    {
        type: INCOME_TYPES.AI_AN,
        isOnlyPositiveAvailable: true,
        questionText: 'modals.income_deduction.ai_an',
        notice: {
            text: 'common.no_text',
            positionOnPage: null
        },
        additionalInput: {
            positionOnPage: null
        },
        frequencyOptions: 'type_1'
    },
];

export const DEDUCTIONS_SOURCES = [
    {
        type: EXPENSE_TYPES.ALIMONY,
        isOnlyPositiveAvailable: true,
        questionText: 'common.no_text',
        notice: {
            text: 'common.no_text',
            positionOnPage: null
        },
        additionalInput: {
            positionOnPage: null
        },
        frequencyOptions: 'type_6'
    },
    {
        type: EXPENSE_TYPES.STUDENT_LOAN_INTEREST,
        isOnlyPositiveAvailable: true,
        questionText: 'common.no_text',
        notice: {
            text: 'common.no_text',
            positionOnPage: null
        },
        additionalInput: {
            positionOnPage: null
        },
        frequencyOptions: 'type_6'
    },
    {
        type: EXPENSE_TYPES.BUSINESS,
        isOnlyPositiveAvailable: true,
        questionText: 'common.no_text',
        notice: {
            text: 'common.no_text',
            positionOnPage: null
        },
        additionalInput: {
            positionOnPage: null
        },
        frequencyOptions: 'type_6'
    },
    {
        type: EXPENSE_TYPES.HEALTH_SAVING_ACCOUNT,
        isOnlyPositiveAvailable: true,
        questionText: 'common.no_text',
        notice: {
            text: 'common.no_text',
            positionOnPage: null
        },
        additionalInput: {
            positionOnPage: null
        },
        frequencyOptions: 'type_6'
    },
    {
        type: EXPENSE_TYPES.SELF_EMPLOYMENT_TAX,
        isOnlyPositiveAvailable: true,
        questionText: 'common.no_text',
        notice: {
            text: 'common.no_text',
            positionOnPage: null
        },
        additionalInput: {
            positionOnPage: null
        },
        frequencyOptions: 'type_6'
    },
    {
        type: EXPENSE_TYPES.SELF_EMPLOYED_PLANS,
        isOnlyPositiveAvailable: true,
        questionText: 'common.no_text',
        notice: {
            text: 'common.no_text',
            positionOnPage: null
        },
        additionalInput: {
            positionOnPage: null
        },
        frequencyOptions: 'type_6'
    },
    {
        type: EXPENSE_TYPES.SELF_EMPLOYED_HEALTH_INSURANCE,
        isOnlyPositiveAvailable: true,
        questionText: 'common.no_text',
        notice: {
            text: 'common.no_text',
            positionOnPage: null
        },
        additionalInput: {
            positionOnPage: null
        },
        frequencyOptions: 'type_6'
    },
    {
        type: EXPENSE_TYPES.EARLY_WITHDRAWAL_PENALTIES,
        isOnlyPositiveAvailable: true,
        questionText: 'common.no_text',
        notice: {
            text: 'common.no_text',
            positionOnPage: null
        },
        additionalInput: {
            positionOnPage: null
        },
        frequencyOptions: 'type_6'
    },
    {
        type: EXPENSE_TYPES.IRA,
        isOnlyPositiveAvailable: true,
        questionText: 'common.no_text',
        notice: {
            text: 'common.no_text',
            positionOnPage: null
        },
        additionalInput: {
            positionOnPage: null
        },
        frequencyOptions: 'type_6'
    },
    {
        type: EXPENSE_TYPES.MOVING,
        isOnlyPositiveAvailable: true,
        questionText: 'common.no_text',
        notice: {
            text: 'common.no_text',
            positionOnPage: null
        },
        additionalInput: {
            positionOnPage: null
        },
        frequencyOptions: 'type_6'
    },
    {
        type: EXPENSE_TYPES.EDUCATOR,
        isOnlyPositiveAvailable: true,
        questionText: 'common.no_text',
        notice: {
            text: 'common.no_text',
            positionOnPage: null
        },
        additionalInput: {
            positionOnPage: null
        },
        frequencyOptions: 'type_6'
    },
    {
        type: EXPENSE_TYPES.OTHER,
        isOnlyPositiveAvailable: true,
        questionText: 'common.no_text',
        notice: {
            text: 'common.no_text',
            positionOnPage: null
        },
        additionalInput: {
            positionOnPage: null
        },
        frequencyOptions: 'type_6'
    },
];

